import axios from "axios";

import { LMS_TOKEN } from "../../../utils/cookiesmanager";
import { LMS_BASE_URL } from "../../../utils/http/http-common";

export const getCourseCompletionStatusApiCall = async () => {
  const token = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.get(
      `${LMS_BASE_URL}/course/GetShowCourseCompleteStatus`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};